import React, { useState } from "react";
import { Button, Form, Input, message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { addDoc, collection } from "firebase/firestore";
import { firestore } from "../../../../../configs/FirebaseConfig";
import { FIRESTORE_PRICE_LISTS_TABLE, FIRESTORE_REGIONS_TABLE } from "../../../../../constants/FirestoreConstant";
import { COMPANY_COUNTRY_CODE } from "../../../../../constants/CompanyConstants";
import { useAuth } from "../../../../../data/hooks/firebase/useAuth";
import dayjs from "dayjs";

const AddPriceListModal = ({ visible, onClose }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { email } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      const newPriceList = {
        name: values.name,
        type: "customer",
        customPrices: {},
        createdAt: dayjs().unix(),
        createdBy: email,
        updatedAt: dayjs().unix(),
        updatedBy: email,
      };

      await addDoc(
        collection(firestore, FIRESTORE_REGIONS_TABLE, COMPANY_COUNTRY_CODE, FIRESTORE_PRICE_LISTS_TABLE),
        newPriceList,
      );

      message.success(t("notifications.price_list_created"));
      form.resetFields();
      onClose();
    } catch (error) {
      console.error("Error creating price list:", error);
      message.error(t("notifications.error_creating_price_list"));
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title={t("add_price_list")}
      open={visible}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          {t("cancel")}
        </Button>,
        <Button key="submit" type="primary" loading={loading} onClick={handleSubmit}>
          {t("create")}
        </Button>,
      ]}
      width={500}
      centered
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="name"
          label={t("price_list_name")}
          rules={[{ required: true, message: t("form.enter_price_list_name") }]}
        >
          <Input placeholder={t("form.enter_price_list_name")} maxLength={100} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddPriceListModal;
